export const defaultValues = {
  heading: 'Fragebogen für Immobilienbewertung erfolgreich ausgefüllt',
  title: 'Genauere Bewertung erhalten',
  description:
    'Um Ihnen eine genaue Analyse Ihrer Immobilie zukommen lassen zu können, benötigen wir weitere Daten von Ihnen. Dazu wird Sie in Kürze ein Kundenberater telefonisch kontaktieren.',
  buttonText: 'Zurück zur Website',
  bookCallButtonText: 'Telefontermin vereinbaren',
  resetButtonText: 'Neustarten',
  linkText: 'Zum persönlichen Bereich',
  linkUrl: '',
} as const;
